import Loader from './loader.vue';

export default Loader;
